var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TreeView } from '@juvare/common-web-ui/TreeView';
import emptyContentImageSmall from '@juvare/common-web-ui/assets/emptyContentImageSmall.svg';
import { Box, CircularProgress, LinearProgress, Typography } from '@mui/material';
import React from 'react';
import { useCommonDataTableUiTranslation } from '../../hooks';
export function TreeContent(_a) {
    var { loading } = _a, props = __rest(_a, ["loading"]);
    const { t } = useCommonDataTableUiTranslation();
    return (React.createElement(Box, { sx: { position: 'relative', '& [role=treegrid]>[role=row]:last-child .tree-item-border:last-child': { display: 'none' } } },
        loading && props.items.length > 0 && (React.createElement(Box, { sx: { position: 'absolute', left: 0, top: 0, right: 0 } },
            React.createElement(LinearProgress, null))),
        props.items.length > 0 && React.createElement(TreeView, Object.assign({}, props)),
        props.items.length === 0 && loading && (React.createElement(Box, { sx: { py: 16, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 } },
            React.createElement(CircularProgress, { size: 54 }))),
        props.items.length === 0 && !loading && (React.createElement(Box, { sx: { py: 12, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 4 } },
            React.createElement("img", { src: emptyContentImageSmall, alt: '' }),
            React.createElement(Typography, { variant: 'subtitle1' }, t('thereIsNoData'))))));
}
